import { Box } from '@mui/material';
import BasePage from './BasePage';
import AgentClientChat from '../components/AgentClientChat';
import { useClient } from '../contexts/ClientContext';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const AgentChatPage = () => {
  const { isAuthenticated } = useAuth();
  const { hasAgent, agent } = useClient();

  // Redirect if not authenticated or no agent
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!hasAgent) {
    return <Navigate to="/" replace />;
  }

  const handleClose = () => {
    // Navigate back to home or previous page when chat is closed
    window.history.back();
  };

  return (
    <BasePage
      title={`Chat with ${agent?.name || 'Your Agent'} | CribCritic`}
      description="Chat directly with your real estate agent for personalized assistance"
      keywords="agent chat, real estate agent, property consultation"
    >
      <Box sx={{ 
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}>
        <AgentClientChat 
          open={true}
          onClose={handleClose}
        />
      </Box>
    </BasePage>
  );
};

export default AgentChatPage;